import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DispatchDeviceAddPageComponent } from './dispatch-device-add-page.component';

const routes: Routes = [
  {
    path: 'dispatch-device-add-page',
    data: { name: 'Dispatch-Device-Add-Page', isTab: false },
    component: DispatchDeviceAddPageComponent,
  },
  {
    path: 'dispatch-device-add-page/:id',
    component: DispatchDeviceAddPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DispatchDeviceAddPageRoutingModule {}
